// removed by extract-text-webpack-plugin
module.exports = {"colorWhite":"#ffffff","colorModalOverlay":"undefined","colorBoxShadowDark":"rgba(49, 47, 48, 0.15)","unit":"5px","content":"admin-modal__content____2kee9","messageContent":"admin-modal__messageContent____2Fchl admin-modal__content____2kee9","overlay":"admin-modal__overlay____3eRxd"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/components/admin-modal/admin-modal.css
// module id = 264
// module chunks = 0